export interface ControlRect {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export function isControlOnScreen(rect: ControlRect, width: number, height: number) {
  return rect.bottom > 0 && rect.top < height && rect.right > 0 && rect.left < width;
}

export function floatingControlMustHide(
  floating: ControlRect,
  controls: ControlRect[],
  protectedControls: ControlRect[],
  width: number,
  height: number,
) {
  if (protectedControls.some(rect => isControlOnScreen(rect, width, height))) return true;
  return controls.some(rect => isControlOnScreen(rect, width, height) &&
    rect.left < floating.right + 8 && rect.right > floating.left - 8 &&
    rect.top < floating.bottom + 8 && rect.bottom > floating.top - 8);
}